import React from 'react';


import { CSSTransition } from 'react-transition-group';
import { range } from 'lodash-es';

import Helmet from './common/Helmet'

import { history } from '../history'

import {
  LocalizedLanguageObjects,
  LanguageCodeEnglish,
} from '../languageUtils'

import {
  baseDomain,
  recordLinkClickGA,
  ProductionGlossaryBaseUrl,
  getCurrentYear,
} from '../utils'

import {
  NeuroFitNamedLogoSvg,
} from '../constants/svgs'

const containerStyle = {textAlign: "start", height: "100%", width: "100vw", overflowX: "hidden", overflowY: "scroll"}


class LearnSitemapPage extends React.Component {
  constructor(props){
     super(props)
     this.state = {
        learnMoreRef: React.createRef(),
        headerColor: "transparent",
        dropShadowColor: "transparent",
        show: true,
        showIframe: false,
     }
  }

  handleOnClickLearnMore = (event) => {
      //.current is verification that your element has rendered
      if(this.state.learnMoreRef.current){
          this.state.learnMoreRef.current.scrollIntoView({ 
             behavior: "smooth", 
             block: "nearest"
          })
      }
  }

  updateHeaderColorOnContainerScroll = e => {
    if (e.target.scrollTop > 0) {
      const alpha = Math.min(0.5, e.target.scrollTop / 500)
      const headerColor = `rgba(255, 255, 255, ${alpha/1.5})`
      const dropShadowColor = `rgba(0, 0, 0, ${alpha/3.0})`
      this.setState({headerColor, dropShadowColor/* `rgba(53, 63, 106, ${alpha}`*/})
    } else {
      this.setState({headerColor: "transparent", dropShadowColor: "transparent"})
    }

    if (e.target.scrollTop > 400) {
      this.setState({showIframe: true})
    }
  }

  componentDidMount() {
    this.setState({show: true})
    this.scrollingContainerRef.addEventListener('scroll', this.updateHeaderColorOnContainerScroll)
  }

  render() {

    const {
      safeAreaInsets,
      innerHeight,
      formFields,
      isNative,
    } = this.props

    const currentYear = getCurrentYear()

    const {show, learnMoreRef, scrollingContainerRef, headerColor, dropShadowColor, showIframe} = this.state

    const filteredLanguageObjects = LocalizedLanguageObjects.filter(llo => llo.language_code !== LanguageCodeEnglish)

    return (
      <div style={{height: innerHeight}}>
        <Helmet
          title={"Nervous System + Somatics Research Glossary | NEUROFIT"}
          description={"Evidence-based insights used by {{hp_count}}+ health professionals. Explore {{count}}+ terms on nervous system regulation, stress resilience, and somatic practices."}
          href={ProductionGlossaryBaseUrl}
        />
        <div style={{position: "fixed", left: 0, top: 0, height: innerHeight, overflow: "hidden", backgroundColor: "#EDEEF2"}}>
          <div style={{position: "fixed", top: 0, left: 0, right: 0, height: safeAreaInsets.top, backgroundColor: "#000000", zIndex: 2000}} />
          <div style={{position: "fixed", top: 0, left: 0, right: 0, boxShadow: "0px 2px 0px 0px black", display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 12 + safeAreaInsets.top, paddingInlineStart: "min(40px, 7.5%)", paddingInlineEnd: "min(20px, 4%)", paddingBottom: 12, backgroundColor: "white", zIndex: 1000}}>
            <NeuroFitNamedLogoSvg
              logoSize={"min(4.25vw, 18px)"}
              color={"#000000"}
              onClick={() => window.location = "/"}
            />
            <div style={{display: "flex", alignItems: "center"}}>
              <a
                href={"/"}
                rel="noopener noreferrer"
                style={{fontFamily: "Futura Medium", textDecoration: "none", fontSize: "min(4vw, 15px)", textTransform: "uppercase", color: "#000000", cursor: "pointer"}}
              >
                {"Home"}
              </a>
            </div>
          </div>
          <div 
            id={"landing-page-container"}
            className={"disable-scrollbars"}
            ref={elem => this.scrollingContainerRef = elem}
            style={containerStyle}
          >
            <div style={{textAlign: "start", width: "100vw"}}>
              <div style={{color: "black", width: "100%", display: "flex", justifyContent: "center", alignItems: "top", marginTop: "calc(60px + 5vh)"}}>
                <div style={{width: "85%", maxWidth: 700}}>
                  <h1 style={{marginTop: 20, fontSize: "min(8vw, 40px)", textAlign: "start", fontFamily: "Futura", textTransform: "uppercase"}}>
                    {"Research-Backed Nervous System Glossary"}
                  </h1>
                  <h2 style={{marginTop: 20, marginBottom: "8vh", fontSize: "min(6vw, 26px)", textAlign: "start", fontFamily: "Futura Book"}}>
                    {"Access evidence-based definitions and insights on nervous system regulation, stress resilience, and somatic practices. Select your language to begin:"}
                  </h2>
                  <a
                    style={{fontFamily: "Futura Medium", display: "block", margin: "3vh 0px", color: "#000000", fontSize: "min(6vw, 26px)", textUnderlineOffset: "3.5px", textDecorationThickness: "0.1em", cursor: "pointer"}}
                    rel="noreferrer noopener"
                    href={`/nervous-system-glossary/${LanguageCodeEnglish}`}
                  >
                    {"English"}
                  </a>
                  {filteredLanguageObjects.map(({language_code, localized_name}) => (
                    <a
                      key={language_code}
                      style={{fontFamily: "Futura Medium", display: "block", margin: "3vh 0px", color: "#000000", fontSize: "min(5.5vw, 22px)", textUnderlineOffset: "3.5px", textDecorationThickness: "0.1em", cursor: "pointer"}}
                      rel="noreferrer noopener"
                      href={`/nervous-system-glossary/${language_code}`}
                    >
                      {localized_name}
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div style={{textAlign: "start", width: "100vw"}}>
              <div style={{marginTop: 15, padding: 15, fontSize: "min(3.5vw, 16px)", fontFamily: "Futura", display: "flex", alignItems: "center", "justifyContent": "space-between"}}>
                <div style={{display: "inline-block"}}>
                  <span style={{color: "#c1c4d2"}}>
                    {`© NEUROFIT ${currentYear}`}
                  </span>
                  <span style={{display: "inline-block", color: "#c1c4d2", margin: "0px 0.5em", fontSize: "min(2vw, 10px)"}}>
                    {"•"}
                  </span>
                  <span style={{color: "#c1c4d2"}}>
                    {"ALL RIGHTS RESERVED"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default LearnSitemapPage;